import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { LanguageProvider } from './contexts/LanguageContext';
import { GoogleCalendarProvider } from './contexts/GoogleCalendarContext';

import { BrowserRouter } from 'react-router-dom';

if (window.location.pathname.startsWith('/api/')) {
  // If the Service Worker mistakenly intercepts an API route (like Facebook OAuth callback),
  // unregister the SW and force the browser to reload from the network (hitting the backend).
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then(registrations => {
      registrations.forEach(r => r.unregister());
      window.location.reload();
    });
  } else {
    window.location.reload();
  }
} else {
  ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
      <LanguageProvider>
        <GoogleCalendarProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </GoogleCalendarProvider>
      </LanguageProvider>
    </React.StrictMode>
  );
}
